<template>
  <div>
    <b-button
      v-if="showRefreshButton"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      v-b-tooltip.hover.v-primary="'Refresh Table'"
      class="custom-button-color mr-1"
      size="sm"
      @click="onClickRefresh()"
    >
      <img
        src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmZmZmYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1yZWZyZXNoLWNjdyI+PHBhdGggZD0iTTIxIDEyYTkgOSAwIDAgMC05LTkgOS43NSA5Ljc1IDAgMCAwLTYuNzQgMi43NEwzIDgiLz48cGF0aCBkPSJNMyAzdjVoNSIvPjxwYXRoIGQ9Ik0zIDEyYTkgOSAwIDAgMCA5IDkgOS43NSA5Ljc1IDAgMCAwIDYuNzQtMi43NEwyMSAxNiIvPjxwYXRoIGQ9Ik0xNiAxNmg1djUiLz48L3N2Zz4="
      >
    </b-button>
    <b-dropdown
      id="dropdown-right"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      split-class="custom-button-color-blur unable-pointer"
      toggle-class="custom-button-color"
      class="dropdown-no-scroll"
      right
      split
      size="sm"
    >
      <template v-slot:button-content>
        <feather-icon
          icon="DownloadIcon"
          size="20"
        />
      </template>
      <b-dropdown-item>
        <JsonExcel
          class="btn p-0"
          :data="items"
          :name="name"
          :fields="json_fieldz"
          type="csv"
          :escape-csv="false"
        >
          <div class="d-flex">
            <img
              src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiM2NjY2NjYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1maWxlLXgiPjxwYXRoIGQ9Ik0xNC41IDJINmEyIDIgMCAwIDAtMiAydjE2YTIgMiAwIDAgMCAyIDJoMTJhMiAyIDAgMCAwIDItMlY3LjVMMTQuNSAyeiIvPjxwb2x5bGluZSBwb2ludHM9IjE0IDIgMTQgOCAyMCA4Ii8+PGxpbmUgeDE9IjkuNSIgeDI9IjE0LjUiIHkxPSIxMi41IiB5Mj0iMTcuNSIvPjxsaW5lIHgxPSIxNC41IiB4Mj0iOS41IiB5MT0iMTIuNSIgeTI9IjE3LjUiLz48L3N2Zz4="
            >
            <div class="left-name">
              Excel
            </div>
            <div class="right-name">
              (Page)
            </div>
          </div>
        </JsonExcel>
      </b-dropdown-item>
      <b-dropdown-item v-if="(fetch && !queueEnable) || (fetch && queueEnable && store.getters.permissions.filter(permission => permission === queuePermission).length > 0)">
        <JsonExcel
          class="btn p-0"
          :fetch="fetch"
          :before-generate="show_custom_popup? __showJsonDownloadAlertForAllOrders : __showJsonDownloadAlert"
          :fields="json_fieldz"
          type="csv"
          :escape-csv="false"
          :name="bulkname"
        >
          <div class="d-flex">
            <img
              src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiM2NjY2NjYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1maWxlLXgtMiI+PHBhdGggZD0iTTQgMjJoMTRhMiAyIDAgMCAwIDItMlY3LjVMMTQuNSAySDZhMiAyIDAgMCAwLTIgMnY0Ii8+PHBhdGggZD0iTTE0IDJ2Nmg2Ii8+PHBhdGggZD0ibTMgMTIuNSA1IDUiLz48cGF0aCBkPSJtOCAxMi41LTUgNSIvPjwvc3ZnPg=="
            >
            <div class="left-name">
              Excel
            </div>
            <div class="right-name">
              (All)
            </div>
          </div>
        </JsonExcel>
      </b-dropdown-item>
      <b-dropdown-item v-if="tableData && !useAdvancedPdf">
        <JsPdf
          :table-fields="tableFields"
          :table-data="tableData"
          :title="title"
        />
      </b-dropdown-item>
      <b-dropdown-item v-if="tableFields && useAdvancedPdf">
        <JsPdfAll
          :table-fields="tableFields"
          :table-data="tableData"
          :title="title"
          :fetch="fetch"
          :file-name="fileName"
        />
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import {
  BButton, VBTooltip, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import JsPdf from '@/components/AllOrders/JsPdf/JsPdf.vue'
import JsPdfAll from '@/components/AllOrders/JsPdf/JsPdfAll.vue'
import Ripple from 'vue-ripple-directive'
import JsonExcel from 'vue-json-excel'
import store from '@/store'

export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  components: {
    BButton,
    BDropdown,
    BDropdownItem,
    JsonExcel,
    JsPdf,
    JsPdfAll,
  },
  props: {
    fetch: {
      type: Function,
      default: null,
    },
    name: {
      type: String,
      required: true,
    },
    bulkname: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    // eslint-disable-next-line
    json_fieldz: {
      type: Object,
      required: true,
    },
    tableFields: {
      type: Array,
      default: () => {},
    },
    tableData: {
      type: Array,
      default: () => {},
    },
    title: {
      type: String,
      default: '',
    },
    showRefreshButton: {
      type: Boolean,
      default: true,
    },
    // eslint-disable-next-line
    show_custom_popup: {
      type: Boolean,
      default: false,
    },
    queueEnable: {
      type: Boolean,
      default: false,
    },
    queuePermission: {
      type: String,
      default: '',
    },
    fileName: {
      type: String,
      default: 'Data Export.pdf',
    },
    useAdvancedPdf: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      store,
    }
  },
  methods: {
    onClickRefresh() {
      this.$emit('refresh')
    },
  },
}
</script>
<style scoped>
.custom-button-color {
  background-color: #4186f5 !important;
  border-color: #4186f5 !important;
}
.custom-button-color:enabled {
  background-color: #4186f5 !important;
  border-color: #4186f5 !important;
}
.custom-button-color-blur {
  background-color: #6da5ff !important;
  border-color: #6da5ff !important;
}
.left-name {
  font-weight: bolder;
  margin-left: 5px;
  margin-top: 3px;
  color: #666666;
}
.right-name {
  margin-left: 3px;
  margin-top: 3px;
  color: #666666;
}
.unable-pointer {
  pointer-events: none;
}
</style>
